import React, { useContext } from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import { ThemeContext } from '../../context/ThemeContext'
import { textStyles } from '../../../style'
import Haptics from '../../haptics'

type StarRatingProps = {
  value: number
  onChange: (value: number) => void
  label?: string
  required?: boolean
  errorText?: string
  disabled?: boolean
  max?: number
  size?: number
}

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  label,
  required,
  errorText,
  disabled,
  max = 5,
  size = 28,
}: StarRatingProps): React.ReactElement => {
  const theme = useContext(ThemeContext)
  const { primary, textMain } = theme.theme.colors

  return (
    <View style={{ gap: 4 }}>
      {label && (
        <Text style={[textStyles.label, { color: textMain }]}>
          {label}
          {required && <Text style={[textStyles.label, { color: 'red' }]}> *</Text>}
        </Text>
      )}
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 16 }}>
        {Array.from({ length: max }).map((_, index) => {
          const starValue = index + 1
          const filled = starValue <= value
          return (
            <TouchableOpacity
              key={starValue}
              onPress={() => {
                if (disabled) return

                if (starValue === 1) {
                  Haptics.impactLight()
                } else if (starValue === 2 || starValue === 3) {
                  Haptics.impactMedium()
                } else if (starValue === 4 || starValue === 5) {
                  Haptics.impactHeavy()
                }

                onChange(starValue)
              }}
              hitSlop={10}
              disabled={disabled}
            >
              <Ionicons
                name={filled ? 'star' : 'star-outline'}
                size={size}
                color={filled ? primary : textMain}
              />
            </TouchableOpacity>
          )
        })}
      </View>
      {errorText && (
        <Text style={[textStyles.subscript, { color: 'red' }]}>{errorText}</Text>
      )}
    </View>
  )
}

export default StarRating


